<template>
  <v-autocomplete
    v-model="selectedSchool"
    :search-input.sync="search"
    :loading="schoolsLoading"
    :items="schools"
    item-text="site_name"
    item-value="site_code"
    cache-items
    class="mx-3"
    flat
    placeholder="Start typing school name..."
    prepend-icon="mdi-school"
    hide-no-data
    hide-details
    solo-inverted
    return-object
  >
    <template v-slot:item="data">
      <v-list-item-avatar
        color="indigo"
        class="headline font-weight-light white--text"
      >
        PS
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="data.item.site_name + ' (' + data.item.site_code + ')'"></v-list-item-title>
        <v-list-item-subtitle v-if="data.item.site_street && data.item.site_suburb"
                              v-text="data.item.site_street + ', ' + data.item.site_suburb"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
  import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';

  export default {
    name: "SchoolSearchInput",
    data() {
      return {
        search: null,
        timeout: null,
      };
    },
    computed: {
      selectedSchool: {
        get() {
          return this.$store.selectedSchool;
        },
        set(value) {
          this.$store.commit('setSchool', value);
        }
      },
      ...mapState(['schoolsLoading']),
      ...mapGetters(['schoolsResults', 'schoolsResultsNames']),
    },
    methods: {
      ...mapActions(['searchSchool']),
      ...mapMutations(['setSchool']),
    },
    watch: {
      search(val) {
        if (val && val !== this.selectedSchool) {
          if (this.timeout) {
            clearTimeout(this.timeout);
          }
          this.timeout = setTimeout(() => this.searchSchool(val), 400);
        }
      }
    }
  }
</script>

<style scoped>

</style>
